import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxGoToastComponent } from '@go-modules/components/go-toast/go-toast.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule
	],
	declarations: [
		NgxGoToastComponent
	],
	exports: [
		NgxGoToastComponent
	]
})
export class GoToastModule {}
